// extracted by css-extract-rspack-plugin
export default {"banner":"banner-PKt0_W","icon":"icon-kmROt7"};